import { Tabs } from 'expo-router';

import { HapticTab } from '@/components/haptic-tab';
import { IconSymbol } from '@/components/ui/icon-symbol';

export default function StudentLayout() {
  return (
    <Tabs
      screenOptions={{
        headerShown: false,
        tabBarButton: HapticTab,
        tabBarActiveTintColor: '#1F5A37',
        tabBarInactiveTintColor: '#718472',
        tabBarStyle: {
          backgroundColor: '#FFFFFF',
          borderTopColor: '#E3ECE4',
        },
      }}>
      <Tabs.Screen
        name="index"
        options={{
          title: 'Home',
          tabBarIcon: ({ color }) => <IconSymbol color={color} name="house.fill" size={24} />,
        }}
      />
      <Tabs.Screen
        name="account"
        options={{
          title: 'Account',
          tabBarIcon: ({ color }) => <IconSymbol color={color} name="person.fill" size={24} />,
        }}
      />
    </Tabs>
  );
}
